import React, { useContext } from 'react';
import {
  Button,
  Dialog,
  DialogSurface,
  DialogBody,
  DialogContent,
  DialogTitle,
  DialogActions,
  mergeClasses,
} from '@fluentui/react-components';
import { Dismiss24Regular } from '@fluentui/react-icons';

import { I18nContext } from '@bingads-webui-react/i18n-context';

import { I18n } from './types';
import { useDialogContainerStyles } from './styles';

export const ToolsDialogContainer: React.FC<{
  open: boolean;
  children: React.ReactNode;
  onClose: () => void;
}> = ({
  open, children, onClose,
}) => {
  const i18n: I18n = useContext(I18nContext);
  const classes = useDialogContainerStyles();

  return (
    <Dialog open={open}>
      <DialogSurface className={mergeClasses('tools-dialog', classes.surface, classes.surfaceMobileView)}>
        <DialogBody className={classes.body}>
          <DialogTitle
            action={(
              <Button
                className="close-dialog-btn"
                icon={<Dismiss24Regular />}
                appearance="subtle"
                aria-label={i18n.getString(_TL_('Close'))}
                onClick={onClose}
              />
            )}
          >
            {i18n.getString(_TL_('Browse all tools')) }
          </DialogTitle>
          <DialogContent>
            {children}
          </DialogContent>
          <DialogActions>
            <Button
              className="close-action"
              aria-label={i18n.getString(_TL_('Close'))}
              onClick={onClose}
            >
              {i18n.getString(_TL_('Close')) }
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};
